export default __webpack_public_path__ + "static/media/client-logo-2.b09648d0.png";